export default "__VITE_ASSET__C_EXzZje__"